import SigninComponent
  from "../lib/bandung/components/Signin/SigninComponent";
import { Stack, Typography } from "@mui/material";
import VideoChatIcon from '@mui/icons-material/VideoChat';

export default function Signin () {
  return (
    <>
      <div className="login-page-wrapper w-full py-10">
        <div className="container-x mx-auto">
          <Stack alignItems={"center"}
                 justifyContent={"center"}
                 width={"100%"}
                 margin={"1em 0"}>
            <SigninComponent
              header={
                <>
                  <img className="w-1/2 p-2" src={`${process.env.PUBLIC_URL}/assets/images/MarketFusionLogoSVG.svg`} alt="MarketFusion Logo" />
                  {/* <VideoChatIcon fontSize={"large"}/>
                  <Typography variant={"h5"}>MarketFusion</Typography> */}
                  <Typography variant={"h6"}>Sign in</Typography>
                </>
              }
              navigateAwayPath={"/dashboard"}
            />
          </Stack>
        </div>
      </div>
    </>
  );
}